



























import type { PropType } from '@nuxtjs/composition-api';
import { computed, defineComponent } from '@nuxtjs/composition-api';
import VaimoSlider from 'molecules/VaimoSlider.vue';
import VaimoRelatedProductCard from 'organisms/VaimoRelatedProductCard.vue';

import { useScreenSize } from '~/diptyqueTheme/composable/useScreenSize';
import type { Product } from '~/modules/catalog/product/types';

export default defineComponent({
  name: 'ProductRelatedProducts',
  components: {
    VaimoSlider,
    VaimoRelatedProductCard
  },
  props: {
    product: {
      type: Object as PropType<Product | null>,
      required: true
    },
    relatedProducts: {
      type: Array as PropType<Product[]>,
      default: () => []
    },
    parentWidth: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const FIXED_WIDTH = {
      mobile: 312,
      desktop: 450
    };
    const PADDING = {
      mobile: 0,
      desktop: 64
    };
    const SLIDES_TO_SHOW = {
      desktop: 4,
      tablet: 2,
      mobile: 3
    };

    const responsiveOptions = [
      {
        breakpoint: 980,
        settings: {
          slidesToShow: SLIDES_TO_SHOW.mobile
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: SLIDES_TO_SHOW.mobile
        }
      }
    ];

    const SPACES_COUNT = 2;

    const { isDesktop } = useScreenSize();

    const productCards = computed(() =>
      props.relatedProducts.length ? props.relatedProducts : [props.product]
    );

    const slidesQuantityVisible = computed(() => {
      if (!isDesktop.value) {
        return SLIDES_TO_SHOW.mobile;
      }
      return props.parentWidth < FIXED_WIDTH.desktop
        ? SLIDES_TO_SHOW.tablet
        : SLIDES_TO_SHOW.desktop;
    });

    const toPx = (value: number): string => `${value}px`;

    const dynamicSpace = computed(() => {
      if (props.parentWidth === 0) {
        return toPx(PADDING.desktop);
      }
      const viewport = isDesktop.value ? 'desktop' : 'mobile';
      const fixedWidth = FIXED_WIDTH[viewport];
      const padding = PADDING[viewport];
      const availableSpace = props.parentWidth - fixedWidth;
      const space =
        availableSpace > 0 ? availableSpace / SPACES_COUNT : padding;
      return toPx(space);
    });

    return {
      productCards,
      dynamicSpace,
      slidesQuantityVisible,
      responsiveOptions
    };
  }
});
